import React from "react"
import { type RouteObject } from "react-router-dom"

import { PermissionGate } from "../../../../components/PermissionGate/PermissionGate.tsx"
import { RoutesPaths } from "../../../../constants/routes.ts"
import { lazyPage } from "../lazyPage.tsx"

const SuppliersPage = lazyPage(
  () => import("../../../SuppliersPage/SuppliersPage.tsx")
)

const SupplierDetailPage = lazyPage(
  () => import("../../../SuppliersPage/SupplierDetailPage")
)
export const supplierRoutes: RouteObject[] = [
  {
    path: RoutesPaths.suppliers.list,
    element: (
      <PermissionGate pages={["suppliers"]}>
        <SuppliersPage />
      </PermissionGate>
    )
  },
  {
    path: RoutesPaths.suppliers.view(":id"),
    element: (
      <PermissionGate pages={["suppliers"]}>
        <SupplierDetailPage />
      </PermissionGate>
    )
  }
]
